import { keyframes } from "styled-components";
import styled from "styled-components";

export const showBannerLineDesktop = rightPosition => keyframes`
  from {
    right: -300px;
    opacity: 0;
    display: none;
  }

  to {
  opacity: 1;
  position: absolute;
  right: ${rightPosition}px;
  }
`;
export const StyledPlayButton = styled.button`
  background: ${({ theme }) => theme.colors.mainPink};
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  padding: 4px 20px 4px 4px;
  border-radius: 26px;
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  align-items: center;

  & span {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #ff4274;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
`;

export const StyledLineIcon = styled.div`
  position: absolute;
  right: 0;
  bottom: ${({ index }) =>
    index === 1
      ? "calc(15% + 114px)"
      : index === 2
      ? "calc(15% + 56px)"
      : "calc(15% )"};

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    display: none;
  }
`;

export const StyledLineDesktopIcon = styled.div`
  display: none;
  bottom: ${({ index }) =>
    index === 1
      ? "calc(10% + 388px)"
      : index === 2
      ? "calc(10% + 195px)"
      : "calc(10%)"};
  position: absolute;
  opacity: 0;
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: ${({ index }) =>
    index === 1 ? "3s" : index === 2 ? "1.5s" : "0s"};
  animation-fill-mode: forwards;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    display: block;
    animation-name: ${props => showBannerLineDesktop(-90)};
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    animation-name: ${props => showBannerLineDesktop(0)};
  }
`;

export const StyledBannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    align-items: flex-start;
    padding-left: 85px;
    max-width: 1280px;
    margin: 0 auto;
    padding-top: 95px;
  }
  @media (min-width: ${({ theme }) => theme.queries.lg}) {
    padding-left: 140px;
  }
`;
export const StyledVideoWrapper = styled.div`
  position: absolute;
  max-width: 700px;
  z-index: 2;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10px;
  overflow: hidden;
  width: 90vw;
  height: auto;

  & video {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 70vw;
    left: auto;
    right: 10vw;
    bottom: 20vh;
    transform: translateX(0%);
  }
  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    bottom: 10vh;
  }
`;
export const BannerImage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100vh;
  background: url("./images/banner-run-man.png");
  mix-blend-mode: normal;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
  opacity: 0.5;
  transform: translate(-50%, -50%);

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
    height: calc(100vh - 90px);
    transform: none;
    background-position: 50% 60%;
    top: 8%;
    left: auto;
    right: 8%;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    max-width: 500px;
    right: 10%;
  }
`;
